import { render, staticRenderFns } from "./Loans.vue?vue&type=template&id=4d12c2b0&"
import script from "./Loans.vue?vue&type=script&lang=js&"
export * from "./Loans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports